// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"passwordProtected-module__wrapper___1z-AQ","formWrapper":"passwordProtected-module__formWrapper___-XdY7"};